export type PostMessageEnvelope = {
  type: string;
  content: string;
  payload: Record<string, unknown>;
};

export const buildPostMessagePayload = (
  type: string,
  data: Record<string, unknown>
): PostMessageEnvelope => ({
  type,
  content: JSON.stringify(data),
  payload: data,
});
